import React from 'react';

class VoucherItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            enteredPrice: this.props.item.price,
            expanded: false,
            item: this.props.item,
            formLoading: false,
            invalid: false
        }

        this.voucherItemRef = React.createRef();
    }

    toggleExpand() {
        if (!this.state.expanded) {
            window.scrollTo(0, this.voucherItemRef.current.offsetTop - 150);
        }

        this.setState((prevState) => ({
            expanded: !prevState.expanded
        }));
    }

    toggleFormLoading() {
        this.setState((prevState) => ({
            formLoading: !prevState.formLoading
        }));
    }

    isPriceInRange(price) {
        return price > 20 && price < 999000000;
    }

    handleInputBlur(event) {
        let inputPrice = parseInt(event.target.value);
        const newPrice = this.isPriceInRange(inputPrice) ? inputPrice : 20;

        this.setState({
            invalid: false,
            enteredPrice: newPrice,
            item: this.getUpdatedItem(newPrice)
        });
    }

    getUpdatedItem(price) {
        return {
            id: -1,
            price: price,
            price_in_cents: price * 100,
            fee: 2,
            fee_in_cents: 200,
            title: price + trans.empty_voucher
        }
    }

    handleInputChange(event) {
        const price = parseInt(event.target.value);
        const invalid = !this.isPriceInRange(price);

        this.setState({
            invalid: invalid,
            enteredPrice: event.target.value
        });

        if (!invalid) {
            this.setState({
                item: this.getUpdatedItem(price)
            });
        }
    }

    renderVoucherInput() {
        const classes = "service-item__input fabe-input voucher-input__amount" +
            (this.state.invalid ? " has-error" : "");

        return (
            <div>
                <input  type="number"
                        className={classes}
                        value={this.state.enteredPrice}
                        disabled={this.state.formLoading}
                        onChange={(event) => this.handleInputChange(event)}
                        onBlur={(event) => this.handleInputBlur(event)}
                />

                {this.state.item.title} {trans.min_5_eur}
            </div>
        )
    }

    handleVoucherClick() {
        if (this.state.item.id == -1 && this.state.enteredPrice.length === 0) {
            this.setState({ invalid: true });
        } else {
            this.props.clickHandler(this.state.item);
        }
    }

    render() {
        return (
            <div ref={this.voucherItemRef} className="service-item">
                <div className="container flex">
                    <div className="service-item__content flex-1 md:flex items-center">
                        <div className="service-item__title flex flex-1 items-center">
                            {this.state.item.id === -1 ? this.renderVoucherInput() : this.state.item.title}
                        </div>
                        <ul className="service-item__details">
                            <li>
                                {trans.currency_prepend}{this.state.item.price}{trans.currency_append}
                            </li>
                        </ul>
                    </div>

                    <div onClick={() => this.handleVoucherClick()} className="service-item__add btn btn-red hidden md:flex">
                        <span className="uppercase">{trans.buy_now}</span>
                    </div>

                    <div onClick={() => this.handleVoucherClick()} className={"service-item__add btn btn-red md:hidden" + (this.state.expanded ? " expanded" : "")}>
                        <span><i className="fas fa-plus"></i></span>
                    </div>
                </div>
            </div>
        )
    }
}

export default VoucherItem;



// WEBPACK FOOTER //
// ./scripts/components/VoucherItem.jsx